import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Label, Menu, Dropdown } from 'semantic-ui-react'

import {
  PATH_ROOT,
  PATH_BATCH_LOOKUP,
  PATH_PRODUCT_NOTICES,
  PATH_BATCH_PRODUCT_CREATOR,
  PATH_BULK_EDITOR,
  PATH_CLUMP_EDITOR,
  PATH_BRAND_THEMES,
  HEADER_BACKGROUND_COLOR,
  PATH_PRODUCTS_EDIT,
  PATH_PRODUCTS_NEW,
} from '../../consts'
import { AppState } from '../../redux/store'
import { CustomMenu } from './styles'
import { Login, LoginState } from '../Login/Login'

export const Header = () => {
  const dispatch = useDispatch()
  const { currentBatchId, searchFunc } = useSelector((state: AppState) => state.ui)
  const currentPath = useSelector((state: any) => state.router.location.pathname)

  useEffect(() => {
    // To detect window refresh and reload events. A defined currentBatchId
    // indicates that the app is in the middle of the batch lookup process.
    // In this case, cancel the event and trigger the browser dialog box to display.
    // [ref] https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload
    // [ref] https://www.geeksforgeeks.org/html-dom-onbeforeunload-event/
    window.onbeforeunload = (e: BeforeUnloadEvent) => {
      if (currentBatchId) {
        // Cancel the event
        e.preventDefault()
        // Chrome requires returnValue to be set
        e.returnValue = ''
      }
    }
  }, [dispatch, currentBatchId])

  return (
    <CustomMenu inverted size="large" borderless style={{ background: HEADER_BACKGROUND_COLOR }}>
      <Menu.Item header link>
        <span role="img" aria-label="yellow heart">
          💛
        </span>
        <Link to={PATH_ROOT}> Jane Data Integration</Link>
      </Menu.Item>
      <Menu.Item name="lookup" active={currentPath === PATH_ROOT} as="div">
        <Link to={PATH_ROOT}>Lookup</Link>
      </Menu.Item>
      <Menu.Item
        name="products"
        active={currentPath.includes(PATH_PRODUCTS_EDIT) || currentPath.includes(PATH_PRODUCTS_NEW)}
        as="div"
      >
        <Link to={PATH_PRODUCTS_NEW}>Products</Link>
      </Menu.Item>
      <Menu.Item active={currentPath === PATH_BULK_EDITOR}>
        <Link to={PATH_BULK_EDITOR}>Bulk Editor</Link>
      </Menu.Item>
      <Menu.Item active={currentPath === PATH_CLUMP_EDITOR}>
        <Link to={PATH_CLUMP_EDITOR}>Clump Editor</Link>
      </Menu.Item>
      <Menu.Item active={currentPath === PATH_BATCH_PRODUCT_CREATOR}>
        <Link to={PATH_BATCH_PRODUCT_CREATOR}>Batch Product Creator</Link>
      </Menu.Item>
      <Menu.Item
        style={{ minWidth: 140 }}
        name="batchLookup"
        active={currentPath === PATH_BATCH_LOOKUP}
        as="div"
      >
        <Link to={PATH_BATCH_LOOKUP}>Batch Lookup</Link>
        <Label
          style={{ display: currentBatchId ? null : 'none' }}
          circular
          color="blue"
          empty
          size="mini"
        />
      </Menu.Item>
      <Menu.Item active={currentPath === PATH_PRODUCT_NOTICES}>
        <Link to={PATH_PRODUCT_NOTICES}>Product Notices</Link>
      </Menu.Item>
      <Menu.Item active={currentPath === PATH_BRAND_THEMES}>
        <Link to={PATH_BRAND_THEMES}>Brand Themes</Link>
      </Menu.Item>
      <Menu.Item position="right">
        <Menu.Item>
          <span style={{ margin: 'auto 15px' }}>{searchFunc?.toUpperCase()} mode</span>
          <Login>
            {({ isAuthenticated, username, logout }: LoginState) => {
              const displayUsername = isAuthenticated
                ? (username as string)
                : isAuthenticated === undefined
                ? 'Unknown'
                : 'Not logged in'
              return (
                <Dropdown item text={displayUsername}>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={logout}>Log out</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )
            }}
          </Login>
        </Menu.Item>
      </Menu.Item>
    </CustomMenu>
  )
}
